// Formie forms are rendered with `initJs: false` (see templates/components/entryTypes/formie-form.twig).
// PrivacyBee blocks every third-party script until its config has loaded and reports that block as a
// script error, which makes Formie 4 give up on reCAPTCHA ("A required form feature could not start").
// So we wait for PrivacyBee, then re-insert the forms to let Formie's DOM observer mount them.
export function initFormieForms() {
    const forms = document.querySelectorAll('form[data-formie-form][data-formie-init="false"]');
    if (!forms.length) return;

    let mounted = false;
    const mount = () => {
        if (mounted) return;
        mounted = true;

        forms.forEach((form) => {
            form.removeAttribute('data-formie-init');
            const marker = document.createComment('');
            form.replaceWith(marker);
            marker.replaceWith(form);
        });
    };

    // While its banner is open, PrivacyBee sets aria-hidden on the page content but leaves it usable.
    // Formie treats a reCAPTCHA inside aria-hidden as invisible and then submits without a token, which
    // the server silently rejects as spam. Unhide the form once the visitor actually works with it.
    const unhideForm = (event) => {
        const form = event.target.closest?.('form[data-formie-form]');
        let hidden = form?.closest('[aria-hidden="true"]');
        while (hidden) {
            hidden.removeAttribute('aria-hidden');
            hidden = hidden.parentElement?.closest('[aria-hidden="true"]');
        }
    };
    document.addEventListener('focusin', unhideForm);
    document.addEventListener('submit', unhideForm, true);

    const usesPrivacyBee = document.querySelector('script[src*="privacybee.io/cookie-banner.js"]');
    if (!usesPrivacyBee || window.PrivacyBee) {
        mount();
        return;
    }

    document.addEventListener('privacybee:ready', mount, { once: true });
    // PrivacyBee never fires "ready" when loading its config fails
    setTimeout(mount, 3000);
}
